<template>

  <body>
    <my-header> </my-header>
    <div class="webbg">
      <div class="web">
        <div class="producttitle">
          个人资料 <span>首页 > 产品定制</span>
        </div>

        <div class="productschedule">
          <a href="javascript:;"
             class="cur">型号选择</a><a href="javascript:;"
             class="cur">选择颜色</a><a href="javascript:;"
             class="cur">个性设计定制</a><a href="javascript:;"
             class="cur">个人资料</a><a href="javascript:;">确认购买</a>
        </div>

        <div class="productsbox clearfl">

          <div class="product-container">

            <div class="productleft">

              <div class="m-productmodel-scroll">
                <div class="productmodel clearfl">
                  <!--左边耳机-->
                  <div class="productmodelleft">
                    <!--自定义上传-->
                    <div class="headsetcustommade">
                      <div class="custommade leftcustomize"
                           v-bind:style="{backgroundImage:'url('+CustomUplod.leftimg+')',      
                            width:CustomUplod.Lwidth + '%',
                            height:CustomUplod.Lheight + '%',
                            left:CustomUplod.Lleft + '%',
                            top:CustomUplod.Ltop + '%',
                            transform:'rotate('+CustomUplod.Lrotate+'deg) scale('+CustomUplod.Lscale+')'
                      }"></div>
                      <div class="headsetsmalllogo"></div>
                    </div>
                    <!--耳机线-->
                    <div class="headsetline" v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.Wleftimg + ')'}"></div>
                    <!--耳机壳-->
                    <div class="headsetmold"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.Krightimg + ')'}"></div>
                    <!--耳机壳加金箔粉-->
                    <div class="headsetgold"
                         v-bind:style="{backgroundImage:'url(' + httpurl +  SelectDesign.KADDleftimg + ')'}"></div>
                    <!--耳机模-->
                    <div class="headsetcover"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.rightimg + ')'}"></div>
                    <!--耳机模加金箔粉-->
                    <div class="headsetother"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.addleftimg + ')'}"></div>
                    <!--耳机logo-->
                    <div class="headsetBiglogo"
                         v-bind:style="{backgroundImage:'url(' + httpurl + DesignMake.leftlogoimg + ')'}"></div>
                  </div>

                  <!--左边耳机-->

                  <!--右边耳机-->
                  <div class="productmodelright">
                    <!--自定义上传-->
                    <div class="headsetcustommade">
                      <div class="custommade rightcustomize"
                           v-bind:style="{backgroundImage:'url('+CustomUplod.rightimg+')',      
                            width:CustomUplod.Rwidth + '%',
                            height:CustomUplod.Rheight + '%',
                            left:CustomUplod.Rleft + '%',
                            top:CustomUplod.Rtop + '%',
                            transform:'rotate('+CustomUplod.Rrotate+'deg) scale('+CustomUplod.Rscale+')'
                      }"></div>
                      <div class="headsetsmalllogo"></div>
                    </div>
                    <!--耳机线-->
                    <div class="headsetline" v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.Wrightimg + ')'}"></div>
                    <!--耳机壳-->
                    <div class="headsetmold"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.Kleftimg + ')'}"></div>
                    <!--耳机壳加金箔粉-->
                    <div class="headsetgold"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.KADDrightimg + ')'}"></div>
                    <!--耳机模-->
                    <div class="headsetcover"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.leftimg + ')'}"></div>
                    <!--耳机模加金箔粉-->
                    <div class="headsetother"
                         v-bind:style="{backgroundImage:'url(' + httpurl + SelectDesign.addrightimg + ')'}"></div>
                    <!--耳机logo-->
                    <div class="headsetBiglogo"
                         v-bind:style="{backgroundImage:'url(' + httpurl + DesignMake.rightlogoimg + ')'}"></div>
                  </div>
                  <!--右边耳机-->
                </div>
              </div>

              <div class="selectheadsettitle">
                <dl class="clearfl">
                  <h3>你的<span class="Pmodel">{{DesginList.Name}}</span></h3>
                  <dt style="width: 100%;">
                    <p><span class="w300">型号：<em class="Pmodel">{{DesginList.Name}}</em></span><span class="w130">￥<i class="modelprice Uniteprice">{{DesginList.Price}}</i></span></p>
                    <p><span class="w300">线材：<em class="PWire">{{SelectDesign.Wname}}</em></span><span class="w130">￥<i class="Wireprice Uniteprice">{{SelectDesign.Wprice}}</i></span></p>
                    <p><span class="w300">左耳面板：<em><i class="Pleftpanel">{{SelectDesign.Mleftname}}</i></em></span><span class="w130"
                            style="position: relative; top: 13px;">￥<i class="panelprice Uniteprice">{{SelectDesign.Mprice}}</i></span></p>
                    <p><span class="w300">右耳面板：<em><i class="Prightpanel">{{SelectDesign.Mrightname}}</i></em></span></p>
                    <p><span class="w300">左耳壳体：<em><i class="Pleftcase">{{SelectDesign.Kleftname}}</i></em></span><span class="w130"
                            style="position: relative; top: 13px;">￥<i class="caseprice Uniteprice">{{SelectDesign.Kprice}}</i></span></p>
                    <p><span class="w300">右耳壳体：<em><i class="Prightcase">{{SelectDesign.Krightname}}</i></em></span></p>
                    <p>
                      <span class="w300">面板（加金箔粉）：

                        <em v-if="SelectDesign.Maddleftnameid===6&&SelectDesign.Maddrightnameid===6">
                          <i class="panelleftplusgold">左</i>
                          <i class="panelrightplusgold">右</i>
                        </em>
                        <em v-if="SelectDesign.Maddleftnameid!==6&&SelectDesign.Maddrightnameid!==6">
                          <i class="panelleftplusgold">左{{SelectDesign.Maddleftname}}</i>
                          <i class="panelrightplusgold">右{{SelectDesign.Maddrightname}}</i>
                        </em>
                        <em v-if="SelectDesign.Maddleftnameid===6&&SelectDesign.Maddrightnameid!==6">
                          <i class="panelleftplusgold">左</i>
                          <i class="panelrightplusgold">右{{SelectDesign.Maddrightname}}</i>
                        </em>
                        <em v-if="SelectDesign.Maddleftnameid!==6&&SelectDesign.Maddrightnameid===6">
                          <i class="panelleftplusgold">左{{SelectDesign.Maddleftname}}</i>
                          <i class="panelrightplusgold">右</i>
                        </em>
                      </span>
                      <span class="w130">￥<i class="panelgoldprice Uniteprice">{{SelectDesign.Maddprice|toFixed(2)}}</i></span></p>
                    <p>
                      <span class="w300">壳体（加金箔粉）：
                        <em v-if="SelectDesign.Kaddleftnameid===7&&SelectDesign.Kaddrightnameid===7">
                          <i class="panelleftplusgold">左</i>
                          <i class="panelrightplusgold">右</i>
                        </em>
                        <em v-if="SelectDesign.Kaddleftnameid!==7&&SelectDesign.Kaddrightnameid!==7">
                          <i class="panelleftplusgold">左{{SelectDesign.Kaddleftname}}</i>
                          <i class="panelrightplusgold">右{{SelectDesign.Kaddrightname}}</i>
                        </em>
                        <em v-if="SelectDesign.Kaddleftnameid===7&&SelectDesign.Kaddrightnameid!==7">
                          <i class="panelleftplusgold">左</i>
                          <i class="panelrightplusgold">右{{SelectDesign.Kaddrightname}}</i>
                        </em>
                        <em v-if="SelectDesign.Kaddleftnameid!==7&&SelectDesign.Kaddrightnameid===7">
                          <i class="panelleftplusgold">左{{SelectDesign.Kaddleftname}}</i>
                          <i class="panelrightplusgold">右</i>
                        </em>

                      </span>
                      <span class="w130">￥<i class="casegoldprice Uniteprice">{{SelectDesign.Kaddprice|toFixed(2)}}</i></span></p>
                    <p>
                      <span class="w300">Logo样式：
                        <em>
                          <i class="leftlogotitle">{{DesignMake.LLogoStyleName}}(左)</i>
                          <i class="rightlogotitle">{{DesignMake.RLogoStyleName}}(右)</i>
                        </em>
                        <!-- <em v-if='logostylenumber==0'>
                          <i class="leftlogotitle">{{DesignMake.LogoStyleName}}（左）</i>
                          <i class="rightlogotitle">{{DesignMake.LogoStyleName}}（右）</i>
                        </em>
                        <em v-if='logostylenumber==1'>
                          <i class="leftlogotitle">{{DesignMake.LogoStyleName}}（左）</i>
                          <i class="rightlogotitle">{{DesignMake.LogoStyleName}}（右）</i>
                        </em> -->
                      </span>
                    </p>
                    <p>
                      <span class="w300">Logo颜色：
                        <em>
                          <i class="leftlogoColour">{{DesignMake.LLogoColorName}}（左）</i>
                          <i class="rightlogoColour">{{DesignMake.RLogoColorName}}（右）</i>
                        </em>

                        <!-- <em v-if="logostylenumber==''&&logoColornumber==''">
                          <i class="leftlogoColour"></i>
                          <i class="rightlogoColour"></i>
                        </em>
                        <em v-if='logostylenumber==0&&logoColornumber==0'>
                          <i class="leftlogoColour">{{DesignMake.LogoColorName}}（左）</i>
                          <i class="rightlogoColour">{{DesignMake.LogoColorName}}（右）</i>
                        </em>
                        <em v-if='logostylenumber==0&&logoColornumber==1'>
                          <i class="leftlogoColour">{{DesignMake.LogoColorName}}（左）</i>
                          <i class="rightlogoColour">{{DesignMake.LogoColorName}}（右）</i>
                        </em>
                        <em v-if='logostylenumber==1&&logoColornumber==1'>
                          <i class="leftlogoColour">{{DesignMake.LogoColorName}}（左）</i>
                          <i class="rightlogoColour">{{DesignMake.LogoColorName}}（右）</i>
                        </em>
                        <em v-if='logostylenumber==1&&logoColornumber==0'>
                          <i class="leftlogoColour">{{DesignMake.LogoColorName}}（左）</i>
                          <i class="rightlogoColour">{{DesignMake.LogoColorName}}（右）</i>
                        </em> -->
                      </span>
                    </p>
                    <p>
                      <span class="w300">个性定制图案：

                        <em class="pattern"
                            v-show="CustomUplod.leftimg==''">无</em>
                        <em class="pattern"
                            v-show="CustomUplod.leftimg!=''">有</em>
                      </span>
                      <span class="w240"
                            v-show="CustomUplod.leftimg!=''">￥
                        <i class="custommadeprice Uniteprice">360</i>
                        此价格不是最终价格
                      </span>
                    </p>
                    <h4>耳机定制完成时间：<span>2-4周</span></h4>
                  </dt>
                </dl>
              </div>

              <div class="selectheadseTotalprice"><span>总价格</span>￥<i class="Colourprice">{{DesignMake.SumPrice|toFixed(2)}}</i></div>

            </div>

            <div class="productright">

              <div class="SubmitInformation">
                <h3>姓名：</h3>
                <label>
                  <input type="text"
                         v-model="makelist.name"
                         class="myname" /></label>
                <h3>包装盒上雕刻的名字：</h3>
                <label>
                  <input type="text"
                         v-model="makelist.Kname"
                         class="diaokename" /></label>
                <h3>电话：</h3>
                <label>
                  <input type="text"
                         v-model="makelist.tel"
                         class="tel" /></label>
                <h3>地址：</h3>
                <label>
                  <textarea v-model="makelist.address"
                            class="address"></textarea></label>

                <h3>耳模快递及单号：</h3>
                <label>
                  <input type="text"
                         v-model="makelist.express"
                         class="ermo" /></label>
                <h3>经销商：</h3>
                <label>
                  <input type="text"
                         v-model="makelist.agent"
                         class="jinxiaoshang" /></label>
              </div>

              <div class="takemanner">
                正常收到您的个人耳模并确认无误后，<br />
                2-4周可以完成耳机的定制。
              </div>

              <div class="save">
                <a @click="save()"
                   class="save_this">

                  <span> 保存</span>

                </a>
              </div>

              <div class="customizeNext show-customizeNext">
                <a @click="back()">上一步</a>
                <a class="cur the_next"
                   @click="next()">下一步</a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import myHeader from "@/views/detailimg";
import { tjdexx, getdeurlid,getimg,gettimg } from "@/api/api";
export default {
  components: { myHeader },
  data () {
    return {
      httpurl: 'http://shop.qdc.com/',
      makelist: {
        name: '',
        Kname: '',
        tel: '',
        address: '',
        express: '',
        agent: '',
      },
      CustomUplod: {
        // leftimg: require("../assets/REDIVG.png"),
        leftimg: '',
        rightimg: '',
        Lwidth: 20.5,
        Lheight: 19.7321,
        Lleft: 44.4167,
        Ltop: 50.134,
        Lrotate: 0,
        Lscale: 1,
        Rwidth: 20.5,
        Rheight: 19.7321,
        Rleft: 44.4167,
        Rtop: 50.134,
        Rrotate: 0,
        Rscale: 1
      },

      SelectDesign: {
        LogoColorName: "",
        LogoStyleName: "",
        SumPrice: 0,
        leftlogoimg: "",
        rightlogoimg: "",
        leftlogoimg: "",
        rightlogoimg: "",
        addleftimg: "",
        addrightimg: "",
        leftimg: "",
        rightimg: "",
        SumPrice: 0,
        PanelOtherid: 4,

        addleftimg: "",
        addrightimg: "",
        //						addleftimg: require("../assets/leftjfkt.png"),
        //						addrightimg: require("../assets/rightjfkt.png"),
        Kleftimg: "",
        Krightimg: "",
        KADDleftimg: "",
        KADDrightimg: "",
        Mleftname: "",
        Mrightname: "",
        Mprice: 0,
        Kaddleftname: "",
        Kaddrightname: "",
        Kaddleftnameid: 3,
        Kaddrightnameid: 3,
        Kaddprice: 0,
        Maddleftname: "",
        Maddrightname: "",
        Maddleftnameid: 4,
        Maddrightnameid: 4,
        Maddprice: 0,
        Kleftname: "",
        Krightname: "",
        Kprice: 0,
        Wname: "",
        Wprice: 0
      },
      DesignMake: {
        LLogoColorNameid: '',
        RLogoColorNameid: '',
        LLogoColorName: '',
        RLogoColorName: '',
        LLogoStyleName: '',
        RLogoStyleName: '',
        LLogoStyleNameid: '',
        RLogoStyleNameid: '',
        SumPrice: 0,
        leftlogoimg: '',
        rightlogoimg: '',

      },
      Price: '',
      Name: '',
      logostylenumber: '',
      logoColornumber: '',
      ukey: 0,
      sjoderid: '',
      ret:''
    }
  },
  created () {
      
      if (sessionStorage.getItem('newmakelist')!==null) {
          this.makelist=JSON.parse(sessionStorage.getItem('newmakelist'))
          
      }
    if (localStorage.getItem('newukey') == '' || localStorage.getItem('newukey') == null) {
      this.ukey = 0
    } else {
      this.ukey = localStorage.getItem('newukey')
    }
    if (localStorage.getItem("newDesginList") != null || localStorage.getItem("newDesginList") != undefined) {
      var list = JSON.parse(localStorage.getItem('newDesginList'));
      encodeURI(encodeURI(list.Description));
      this.DesginList = list
    } else {
      this.DesginList = ''
      this.$message({
        message: "您暂未选择设计型号，我们将帮你返回让你进行选择",
        type: 'error'
      });
      this.$router.push('/Design')
    }

    if (localStorage.getItem("newSelectDesign") != null || localStorage.getItem("newSelectDesign") != undefined) {
      var SelectDesign = JSON.parse(localStorage.getItem('newSelectDesign'));
      this.SelectDesign = SelectDesign
    //   console.log(this.SelectDesign)
    //   console.log(SelectDesign)
    } else {
      this.SelectDesign.Kleftimg = 'uploads/admin/image/20160902/2016090210273171.png'
      this.SelectDesign.Krightimg = 'uploads/admin/image/20160902/2016090210272948.png'
      this.SelectDesign.leftimg = 'uploads/admin/image/20160902/2016090209324618.png'
      this.SelectDesign.rightimg = 'uploads/admin/image/20160902/2016090209324285.png'
    }
    if (localStorage.getItem("newDesignMake") != null || localStorage.getItem("newDesignMake") != undefined) {
      var DesignMake = JSON.parse(localStorage.getItem('newDesignMake'));
      this.DesignMake = DesignMake
    }
    if (localStorage.getItem("newCustomUplod") != null || localStorage.getItem("newCustomUplod") != undefined) {
      
   var CustomUplod = JSON.parse(localStorage.getItem('newCustomUplod'));
      this.CustomUplod = CustomUplod
    }
    if (localStorage.getItem("newlogoColornumber") != null || localStorage.getItem("newlogoColornumber") != undefined) {
      var newlogoColornumber = localStorage.getItem('newlogoColornumber');
      this.logoColornumber = newlogoColornumber

    } else {
      this.logoColornumber = ''
    }
    if (localStorage.getItem("newlogostylenumber") != null || localStorage.getItem("newlogostylenumber") != undefined) {
      var newlogostylenumber = localStorage.getItem('newlogostylenumber');
      this.logostylenumber = newlogostylenumber
    }
    else {
      this.logostylenumber = ''
    }
    // this.getimg()
  },
  computed: {


   

    //      DesignMake () {
    //   return this.$store.state.DesignMake
    // },
    //   CustomUplod () {
    //   return this.$store.state.CustomUplod
    // },
    // DesginList () {
    //   return this.$store.state.DesginList
    // },
    // SelectDesign () {
    //   return this.$store.state.SelectDesign
    // },
    //  logostylenumber () {
    //   return this.$store.state.logostylenumber
    // },
    // logoColornumber () {
    //   return this.$store.state.logoColornumber
    // },
  },
  methods: {
//       getimg(){
// var self = this;
//       var para = {
      
//         Cleftimg: this.CustomUplod.leftimg,
//         Crightimg: this.CustomUplod.rightimg,

//       };
//       getimg.log(para);

//       getdeurlid(para).then(res => {
//         console.log("请求成功", res.data);
//         this.ret=res.data.ret
//         res => {
//           console.info("调用失败", res);
//         };
//       });
//       },
       back () {
      this.$router.push('/DesignMake')
    },
    save () {
       
        if(this.makelist.name==''){
                 this.$message({
                    message: "请输入姓名",
                    type: 'error'
                });
                return;
            }
            if(this.makelist.tel==''){
                 this.$message({
                    message: "请输入电话",
                    type: 'error'
                });
                return;
            }
            //  if(this.makelist.tel.length!==11){
            //      this.$message({
            //         message: "请输入正确的电话号码（11位）",
            //         type: 'error'
            //     });
            //     return;
            // }
            if(this.makelist.address==''){
                 this.$message({
                    message: "请输入地址",
                    type: 'error'
                });
                return;
            }
         if (this.ukey == 0) {
             alert('请先登录')
              window.location.href = 'http://shop.qdc.com/member/login.html?lx=2&fl=2'
         }
          if( localStorage.getItem('imglist')){
               var imglist = JSON.parse(localStorage.getItem('imglist'));
             
         this.CustomUplod.Cleftimg=imglist.url
           this.CustomUplod.Crightimg=imglist.urlt
        }
       
      var self = this;
      var para = {
          
        ukey: this.ukey,
        Cleftimg: this.CustomUplod.Cleftimg,
        Crightimg:  this.CustomUplod.Crightimg,
        Lwidth: this.CustomUplod.Lwidth,
        Lheight: this.CustomUplod.Lheight,
        Lleft: this.CustomUplod.Lleft,
        Ltop: this.CustomUplod.Ltop,
        Lrotate: this.CustomUplod.Lrotate,
        Lscale: this.CustomUplod.Lscale,
        Rwidth: this.CustomUplod.Rwidth,
        Rheight: this.CustomUplod.Rheight,
        Rtop: this.CustomUplod.Rtop,
        Rrotate: this.CustomUplod.Rrotate,
        Rscale: this.CustomUplod.Rscale,
        Maddleftnameid: this.SelectDesign.Maddleftnameid,
        Maddrightnameid: this.SelectDesign.Maddrightnameid,
        Maddleftname: this.SelectDesign.Maddleftname,
        Maddrightname: this.SelectDesign.Maddrightname,
        Maddprice: this.SelectDesign.Maddprice,
        Krightimg: this.SelectDesign.Krightimg,
        KADDleftimg: this.SelectDesign.KADDleftimg,
        rightimg: this.SelectDesign.rightimg,
        addleftimg: this.SelectDesign.addleftimg,
        leftlogoimg: this.DesignMake.leftlogoimg,
        Kleftimg: this.SelectDesign.Kleftimg,
        KADDrightimg: this.SelectDesign.KADDrightimg,
        leftimg: this.SelectDesign.leftimg,
        addrightimg: this.SelectDesign.addrightimg,
        rightlogoimg: this.DesignMake.rightlogoimg,
        Name: this.DesginList.Name,
        Price: this.DesginList.Price,
        Wname: this.SelectDesign.Wname,
        Wprice: this.SelectDesign.Wprice,
        Mprice: this.SelectDesign.Mprice,
        Mrightname: this.SelectDesign.Mrightname,
        Krightname: this.SelectDesign.Krightname,
        Kprice: this.SelectDesign.Kprice,
        Mleftname: this.SelectDesign.Mleftname,
        Kaddleftnameid: this.SelectDesign.Kaddleftnameid,
        Kaddrightnameid: this.SelectDesign.Kaddrightnameid,
        Kaddleftname: this.SelectDesign.Kaddleftname,
        Kaddrightname: this.SelectDesign.Kaddrightname,
        Kaddprice: this.SelectDesign.Kaddprice,
        LLogoStyleName: this.DesignMake.LLogoStyleName,
        RLogoStyleName: this.DesignMake.RLogoStyleName,
        LLogoColorName: this.DesignMake.LLogoColorName,
        RLogoColorName: this.DesignMake.RLogoColorName,
        SumPrice:this.DesignMake.SumPrice,
        Kleftname:this.SelectDesign.Kleftname,
        Wleftimg:this.SelectDesign.Wleftimg,
        Wrightimg:this.SelectDesign.Wrightimg,
        // Desginarr:JSON.stringify([this.DesginList,this.SelectDesign,this.CustomUplod,])
        // // DesginList:JSON.stringify(this.DesginList),
        // SelectDesign:JSON.stringify(this.SelectDesign),
        // CustomUplod:JSON.stringify(this.CustomUplod),

      };
  

      getdeurlid(para).then(res => {
        // console.log("请求成功", res.data);
        this.ret=res.data.ret
        sessionStorage.setItem('ret', res.data.ret)
        // this.$router.push('/DesignShare')
        this.$router.push({
            path: '/DesignShare',
            query: {
              ret: res.data.ret,
            }

          });
          
        res => {
          console.info("调用失败", res);
        };
        
      });
       
     
  this.$store.dispatch("Changemakelist", this.makelist);
   this.$store.dispatch('ChangeCustomUplod', CustomUplod)
      //   this.$router.push('/DesignShare')
    },
    next () {
if(this.makelist.name==''){
                 this.$message({
                    message: "请输入姓名",
                    type: 'error'
                });
                return;
            }
            if(this.makelist.tel==''){
                 this.$message({
                    message: "请输入电话",
                    type: 'error'
                });
                return;
            }
            //  if(this.makelist.tel.length!==11){
            //      this.$message({
            //         message: "请输入正确的电话号码（11位）",
            //         type: 'error'
            //     });
            //     return;
            // }
            if(this.makelist.address==''){
                 this.$message({
                    message: "请输入地址",
                    type: 'error'
                });
                return;
            }
            if(sessionStorage.getItem('ret')!==null){
                this.ret=sessionStorage.getItem('ret')
            }
 if (this.$route.query.state == 1) {
      var self = this;
      var para = {
        ukey: this.ukey,
        token: sessionStorage.getItem('token'),
        DesginList: this.DesginList.designid,//选择的型号
        Mrightid: this.SelectDesign.Mrightnameid,//右耳面板颜色ID
        Mleftid: this.SelectDesign.Mleftnameid,//左耳面板颜色ID
        Mrighttxid: this.SelectDesign.Maddrightnameid,//右耳面板颜色特效ID(若为“取消”则为0)
        Mlefttxid: this.SelectDesign.Maddleftnameid,//左耳面板颜色特效ID(若为“取消”则为0)
        Crightid: this.SelectDesign.Crightnameid,//右耳材质颜色ID
        Cleftid: this.SelectDesign.Cleftnameid,//左耳材质颜色ID
        Krightid: this.SelectDesign.Krightnameid,//右耳壳体颜色ID 
        Kleftid: this.SelectDesign.Kleftnameid,//左耳壳体颜色ID 
        Krighttxid: this.SelectDesign.Kaddrightnameid,//右耳壳体颜色特效ID(若为“取消”则为0)
        Klefttxid: this.SelectDesign.Kaddleftnameid,//左耳壳体颜色特效ID(若为“取消”则为0)
        Wid: this.SelectDesign.Wid,//选取的线材ID
        addleftimg: this.CustomUplod.Cleftimg,//上传的左耳图片地址
        addrightimg: this.CustomUplod.Crightimg,//上传的右耳图片地址
        leftlogo: this.DesignMake.RLogoColorNameid,//选取的左耳logo ID
        rightlogo: this.DesignMake.LLogoColorNameid,//选取的右耳logo ID   
        name: this.makelist.name,//姓名
        Kname: this.makelist.Kname,//	包装盒上雕刻的名字
        express: this.makelist.express,//耳模快递及单号
        agent: this.makelist.agent,//经销商
        address: this.makelist.address,//地址
        tel: this.makelist.tel,//电话号码
        price: this.DesignMake.SumPrice,//全部的总价格
        ret:this.ret
      };
    

      tjdexx(para).then(res => {
        // console.log("请求成功", res.data);
        this.sjoderid = res.data.data
        if (this.$route.query.state == 1) {
            // sessionStorage.setItem("Dsum",this.DesignMake.SumPrice)
          this.$router.push({
            path: '/DesignPurchase',
            query: {
            //   SumPrice: this.DesignMake.SumPrice,
              sjoderid: res.data.data
            }

          });
        } 

        res => {
          console.info("调用失败", res);
        };
      });

 }else{
 this.$message({
            message: "请先保存设计再进行下一步（支付）",
            type: 'error'
          });
          return;
 }

    },


  },
}
</script>

<style scoped>
@import "../../static/newlayout.css";
@import "../../static/global.css";
</style>


// WEBPACK FOOTER //
// src/views/DesignMessage.vue